(function() {
  var replacements = [
    [/Charm offert à partir de/g, 'Cabas offert à partir de'],
    [/CHARM OFFERT/g, 'CABAS OFFERT'],
    [/Charm offert/g, 'Cabas offert'],
    [/charm offert/g, 'cabas offert'],
    [/un charm offert/g, 'un cabas offert'],
    [/votre charm est offert/g, 'votre cabas est offert'],
    [/Free charm from/g, 'Free Tote Bag from'],
    [/FREE CHARM/g, 'FREE TOTE BAG'],
    [/Free charm/g, 'Free Tote Bag'],
    [/free charm/g, 'free Tote Bag'],
    [/A FREE CHARM/g, 'A FREE TOTE BAG'],
    [/your charm is free/g, 'your Tote Bag is free']
  ];

  function normalizeText(value, node) {
    var parent = node.parentElement;
    var giftRow = parent.closest('[data-palas-gift-kind]');
    if (giftRow && parent.closest('.cart__item-name') === parent && value.trim()) {
      var kind = giftRow.getAttribute('data-palas-gift-kind');
      var french = document.documentElement.lang.indexOf('fr') === 0;
      if (kind === 'tote') return french ? 'Votre cabas offert' : 'Your free Tote Bag';
      if (kind === 'charm') return french ? 'Votre charm offert' : 'Your free charm';
    }

    // Only the threshold progress bar still uses legacy charm wording.
    // Campaign banners and real charm products must retain their own copy.
    if (!parent.closest('[data-palas-progress][data-bar-type="dual"]')) return value;

    var next = value;

    replacements.forEach(function(entry) {
      next = next.replace(entry[0], entry[1]);
    });

    return next;
  }

  function shouldSkip(node) {
    var parent = node.parentElement;

    if (!parent) {
      return true;
    }

    return Boolean(parent.closest('script, style, textarea, input'));
  }

  function normalizeNode(root) {
    if (!root) {
      return;
    }

    if (root.nodeType === Node.TEXT_NODE) {
      if (shouldSkip(root)) {
        return;
      }

      var normalized = normalizeText(root.nodeValue, root);
      if (normalized !== root.nodeValue) {
        root.nodeValue = normalized;
      }
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) {
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var textNode;

    while ((textNode = walker.nextNode())) {
      if (shouldSkip(textNode)) {
        continue;
      }

      var nextValue = normalizeText(textNode.nodeValue, textNode);
      if (nextValue !== textNode.nodeValue) {
        textNode.nodeValue = nextValue;
      }
    }
  }

  function init() {
    normalizeNode(document.body);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(normalizeNode);

        if (mutation.type === 'characterData') {
          normalizeNode(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
